import DashboardLayout from "components/layouts/dashboard-layout";
import PageLinks from "components/page-links";
import React from "react";
import Default from "./components/default";

const PromoCards = () => {
  return (
    <DashboardLayout>
      <>
        <PageLinks
          from={{ name: "Overview", link: "/overview" }}
          current="Promo Cards"
        />
        <Default />
      </>
    </DashboardLayout>
  );
};

export default PromoCards;
